import { FormDatePicker } from 'src/components/forms/components/FormDatePicker';
import { FormInput } from 'src/components/forms/components/FormInput';
import { FormRow } from 'src/components/forms/layout/FormRow';

export const CustomerLicenceInfo = () => {
  return (
    <>
      <FormRow>
        <FormInput
          name="driversLicenceNumber"
          label="Driver's Licence Number"
          placeholder="Enter Driver's Licence Number"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
        <FormDatePicker name="licenceExpiryDate" label="Licence Expiry Date" hideOptionalLabel controlStyleProps={{ width: '200px' }} />
      </FormRow>
      <FormRow>
        <FormInput
          name="driversLicenceClass"
          label="Licence Class"
          placeholder="Enter Licence Class"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
        <FormInput
          name="driversLicenceJurisdiction"
          label="Licence Jurisdiction"
          placeholder="Enter Licence Jurisdiction"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
        <FormInput
          name="endorsementsRestrictions"
          label="Endorsements ansd Restrictions"
          placeholder="Enter Endorsements and Restrictions"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
      </FormRow>
    </>
  );
};
